import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import {
  Dialog,
  FlatButton,
  FontIcon,
} from 'material-ui';
import SortableList from '../../../../tc-ui/sortable-list-with-react-dnd/sortable-list';
import DraggableCard from '../../../../tc-ui/sortable-list-with-react-dnd/draggable-card';
import { SmallFlatButton } from '../../../../tc-ui/small-buttons';

class SortPackageGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortType: 'products',
      sortProductId: '',
      ...this.getArrays(props.productsArray),
    };
  }

  componentWillReceiveProps(nextProps) {
    const { productsArray } = this.props;
    if (nextProps.productsArray !== productsArray) {
      this.state = {
        ...this.state,
        ...this.getArrays(nextProps.productsArray),
      };
    }
  }

  getArrays = productsArray => {
    if (!(productsArray && productsArray.length)) {
      return {
        productsArray: [],
        products: [],
        groupedByProductId: {},
      };
    }
    const groupedByProductId = R.groupBy(R.prop('productId'), productsArray);
    return {
      productsArray,
      products: R.keys(groupedByProductId).map(id => ({
        productId: id,
        productName: groupedByProductId[id][0].productName,
        hasRatePackages: groupedByProductId[id].length > 1,
      })),
      groupedByProductId,
    };
  }

  onDragEnds = newArray => {
    const {
      groupedByProductId,
      sortProductId,
      sortType,
    } = this.state;
    if (sortType === 'products') {
      const sortedProductsArray = R.flatten(
        newArray.map(obj => groupedByProductId[obj.productId]),
      );
      this.setState({
        products: newArray,
        productsArray: sortedProductsArray,
      });
    } else {
      this.setState({
        ratePackages: newArray,
      });
    }
  };

  confirmRatePackagesChanges = () => {
    const {
      groupedByProductId,
      sortProductId,
      ratePackages,
    } = this.state;
    const newGroupedByProductId = R.assoc(
      sortProductId,
      ratePackages,
      groupedByProductId,
    );
    const productsArray = R.call(
      R.compose(
        R.flatten,
        R.values,
      ),
      newGroupedByProductId,
    );
    this.setState({
      groupedByProductId: newGroupedByProductId,
      productsArray,
      ratePackages: [],
      sortProductId: '',
      sortType: 'products'
    });
  };

  render() {
    const {
      open,
      saveSorted,
      onRequestClose,
    } = this.props;
    const {
      products,
      productsArray,
      groupedByProductId,
      ratePackages,
      sortType,
    } = this.state;
    const processedData = (() => {
      if (sortType === 'ratePackages') {
        return {
          arrayOfData: ratePackages,
          title: `Reorder rate packages for ${ratePackages[0].productName}`,
        };
      }
      if (sortType === 'products') {
        return {
          arrayOfData: products,
          title: `Reorder Rooms/Products`,
        };
      }
      return {
        arrayOfData: [],
        title: '',
      };
    })();
    return (
      <Dialog
        open={open}
        onRequestClose={onRequestClose}
        autoScrollBodyContent
        contentStyle={{ width: '40%' }}
        bodyStyle={{ padding: '24px' }}
        title={(
          <div
            style={{
              backgroundColor: '#00BCD4',
              color: 'white',
              fontSize: '18px',
              padding: '12px',
            }}
          >
            {processedData.title}
          </div>
        )}
        actions={
          sortType === 'ratePackages' ? (
            <div className="flex-tc-sb">
              <FlatButton
                label="Go Back"
                onTouchTap={this.confirmRatePackagesChanges}
                secondary
                icon={(
                  <FontIcon className="tc-icon-arrow_back" />
                )}
              />
              <div/>
            </div>
          )
          : [
              <FlatButton
                label="Cancel"
                primary
                onTouchTap={onRequestClose}
              />,
              <FlatButton
                label="Confirm"
                secondary
                onTouchTap={() => saveSorted(productsArray)}
              />
          ]
        }
      >
        <SortableList
          arrayOfData={processedData.arrayOfData}
          dragEnds={this.onDragEnds}
          sortable
        >
          {processedData.arrayOfData.map(obj => {
            const name = sortType === 'products'
              ? obj.productName
              : (obj.ratePackageName || 'Primary')
            return (
              <DraggableCard
                key={name}
                className="flex-tc-sb"
                style={{
                  marginTop: '5px',
                  padding: '2px 8px',
                  fontSize: '12px',
                  color: 'rgba(0, 0, 0, 0.9)',
                  border: '1px dashed rgba(0, 0, 0, 0.34)',
                }}
                isDropTarget
                isDragSource
              >
                <div className="flex-tc-sb" style={{ width: '93%' }}>
                  <div style={{ width: 'calc(100% - 180px)', whiteSpace: 'pre-wrap' }}>
                    {name}
                  </div>
                  {obj.hasRatePackages && (
                    <SmallFlatButton
                      label="Reorder Rate Packages"
                      onTouchTap={() => this.setState({
                        sortProductId: obj.productId,
                        sortType: 'ratePackages',
                        ratePackages: groupedByProductId[obj.productId],
                      })}
                      style={{ border: '1px solid rgba(0, 0, 0, 0.64)' }}
                      labelStyle={{ padding: '2px 4px', color: 'rgba(0, 0, 0, 0.64)' }}
                      icon={(
                        <FontIcon
                          className="tc-icon-swap_vert"
                          style={{ color: 'rgba(0, 0, 0, 0.64)' }}
                        />
                      )}
                    />
                  )}
                </div>
                <FontIcon
                  className="tc-icon-swap_vert"
                  style={{ color: 'rgba(0, 0, 0, 0.34)' }}
                />
              </DraggableCard>
            );
          })}
        </SortableList>
      </Dialog>
    );
  }
}
SortPackageGroup.defaultProps = {
  sortType: '',
};

SortPackageGroup.propTypes = {
  open: PropTypes.bool.isRequired,
  productsArray: PropTypes.array.isRequired,
  saveSorted: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default SortPackageGroup;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/left-nav/products/sort-rate-package-group.jsx